var _rect, _style, _text, _text2, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 860,
    height: 520,
    viewBox: "0 0 860 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "text{font-family:\"Noto Serif Georgian\",\"Noto Sans Georgian\",Georgia,serif; font-weight:800; fill:#000; letter-spacing:-1px;} .small{font-weight:700;}")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "",
    x: 520,
    y: 95,
    fontSize: 62,
    textAnchor: "middle",
    transform: "rotate(-3 520 95)"
  }, "\u10DB\u10D0\u10E0\u10D0\u10D3\u10D8\u10E3\u10DA\u10D8")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "",
    x: 430,
    y: 255,
    fontSize: 88,
    textAnchor: "middle",
    transform: "rotate(1 430 255)"
  }, "\u10D0\u10EE\u10D0\u10DA\u10D2\u10D0\u10D6\u10E0\u10D3\u10DD\u10D1\u10D8\u10E1")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "",
    x: 430,
    y: 405,
    fontSize: 66,
    textAnchor: "middle",
    transform: "rotate(-2 430 405)"
  }, "\u10EB\u10D8\u10D4\u10D1\u10D8\u10D7")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.758c253191149711224e5f9defa5ea8d.svg";
export { ForwardRef as ReactComponent };